export const navigationScroll = (to, from, savedPosition) => {
  if (savedPosition) return savedPosition
  if (to.hash) return { el: to.hash, top: 100 }
  if (to.path === from.path) {
    const oldPage = String(from.query?.page || '1')
    const newPage = String(to.query?.page || '1')
    return to.path === '/courses' && oldPage !== newPage ? { el: '#catalog-results', top: 100 } : false
  }
  return { top: 0 }
}

export const trapDialogFocus = (event, panel, close) => {
  if (event.key === 'Escape') { event.preventDefault(); close(); return }
  if (event.key !== 'Tab' || !panel) return
  const focusable = [...panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')]
    .filter(element => element.getClientRects().length && !element.closest('[inert]'))
  const first = focusable[0]
  const last = focusable[focusable.length - 1]
  if (!first) { event.preventDefault(); panel.focus(); return }
  const active = panel.ownerDocument.activeElement
  if (event.shiftKey && (active === first || !panel.contains(active))) { event.preventDefault(); last.focus() }
  else if (!event.shiftKey && (active === last || !panel.contains(active))) { event.preventDefault(); first.focus() }
}
